import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutePaths } from './RoutePaths';
import { UdpComponent } from './udp/udp.component';
import { UserGuidesPageComponent } from './navbar/user-guides-page/user-guides-page.component';
import { IsProjectCreatorGuard } from './shared/guards/is-project-creator-guard.service';
import { IsItSupportGuard } from './shared/guards/is-it-support.guard';
import { IsProcessAdminGuard } from './shared/guards/is-process-admin.guard';
import { CanOpenAdminAreaGuard } from './shared/guards/can-open-admin-area.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RoutePaths.PROJECT_OVERVIEW,
    pathMatch: 'full',
  },
  {
    path: RoutePaths.PROJECT_OVERVIEW,
    loadChildren: () =>
      import('./project-overview/project-overview.module').then(
        (m) => m.ProjectOverviewModule
      ),
  },
  {
    path: RoutePaths.PROJECT_CREATION,
    loadChildren: () =>
      import('./project-creation/project-creation.module').then(
        (m) => m.ProjectCreationModule
      ),
    canActivate: [IsProjectCreatorGuard],
  },
    {
    path: RoutePaths.LESSONS_LEARNT,
    loadChildren: () =>
      import('./lessons-learnt/lessons-learnt.module').then(
        (m) => m.LessonsLearntModule
      ),
      canActivate: [IsItSupportGuard],
  },
  {
    path: RoutePaths.PROJECT_DETAILS,
    loadChildren: () =>
      import('./project-details/project-details.module').then(
        (m) => m.ProjectDetailsModule
      ),
  },
  {
    path: RoutePaths.PROJECT_DETAILS_EMBEDDED,
    loadChildren: () =>
      import('./project-details/project-details.module').then(
        (m) => m.ProjectDetailsModule
      ),
  },
  {
    path: RoutePaths.PROJECT_PARTNERS,
    loadChildren: () =>
      import('./partners-area/partners-area.module').then(
        (m) => m.PartnersAreaModule
      ),
  },
  {
    path: RoutePaths.MY_DIGIRES,
    loadChildren: () =>
      import('./my-digires/my-digires.module').then((m) => m.MyDigiresModule),
  },
  {
    path: RoutePaths.ADMIN_AREA,
    loadChildren: () =>
      import('./admin-area/admin-area.module').then((m) => m.AdminAreaModule),
    canActivate: [CanOpenAdminAreaGuard],
  },
  {
    path: RoutePaths.REPORTS_AREA,
    loadChildren: () =>
      import('./reports-area/reports-area.module').then(
        (m) => m.ReportsAreaModule
      ),
  },
  {
    path: RoutePaths.USER_GUIDES_SLIDES,
    component: UserGuidesPageComponent,
  },
  {
    path: RoutePaths.USER_GUIDES_VIDEOS,
    component: UserGuidesPageComponent,
  },
  {
    path: RoutePaths.PROCESS_MODULE,
    component: UdpComponent,
  },
  {
    path: '**',
    redirectTo: RoutePaths.PROJECT_OVERVIEW,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    useHash: true
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
